const AbstractItem = require('@/lib/Items/AbstractItem');
const ItemType = require('@/lib/Items/ItemType');

class Surcharge extends AbstractItem {
    constructor() {
        super();

        this.icon = 'fa-coins';
        this.itemType = ItemType.SURCHARGE;
    }
}

module.exports = Surcharge;
